<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            id="franquia-voltar"
            data-testid="franquia-voltar"
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'franquias' })"
            :disabled="criandoFranquia"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Franquia
        </h1>
      </v-col>
    </v-row>

    <form @submit.prevent="submitForm">
      <v-row>
        <v-col class="pt-0 pb-0" cols="8">
          <e-label>Nome da Unidade</e-label>

          <v-text-field
            id="franquia-descricao"
            data-testid="franquia-descricao"
            v-model="form.descricao"
            label="Nome da Unidade"
            type="text"
            dense
            solo
            :maxlength="TAMANHO_TEXTO"
            :counter="TAMANHO_TEXTO"
            :error-messages="nomeErro"
            @keypress="(event) => bloquearCaractere(event, CLASSE_NOME)"
            @compositionend.native="(event) => sanitizarNome(event.target.value)"
            @beforeinput="bloquearEmoji"
            @input="sanitizarNome"
          />
        </v-col>

        <v-col class="pt-0 pb-0" cols="2">
          <e-label>Código</e-label>

          <v-text-field
            id="franquia-codigo"
            data-testid="franquia-codigo"
            v-model="form.codigo"
            label="Código"
            type="text"
            dense
            solo
            :maxlength="TAMANHO_CODIGO"
            :counter="TAMANHO_CODIGO"
            @compositionend.native="(event) => sanitizarTexto('codigo', event.target.value)"
            @beforeinput="bloquearEmoji"
            @input="(valor) => sanitizarTexto('codigo', valor)"
          />
        </v-col>

        <v-col class="pt-0 pb-0" cols="2">
          <e-label>CNPJ</e-label>

          <v-text-field
            id="franquia-cnpj"
            data-testid="franquia-cnpj"
            v-model="form.cnpj"
            v-mask="'##.###.###/####-##'"
            label="CNPJ"
            type="text"
            dense
            solo
            :maxlength="TAMANHO_CNPJ"
            :counter="TAMANHO_CNPJ"
            @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
            @compositionend.native="(event) => sanitizarTexto('cnpj', event.target.value)"
            @beforeinput="bloquearEmoji"
            @input="(valor) => sanitizarTexto('cnpj', valor)"
          />
        </v-col>

        <v-col class="pt-0 pb-0" cols="12">
          <h1>Endereço</h1>
        </v-col>

        <v-col class="pt-0 pb-0" cols="2">
          <e-label>CEP</e-label>

          <v-text-field
            id="franquia-cep"
            data-testid="franquia-cep"
            v-model="form.cep"
            v-mask="'#####-###'"
            label="CEP"
            type="text"
            dense
            solo
            :maxlength="TAMANHO_CEP"
            :counter="TAMANHO_CEP"
            :loading="buscandoCep"
            :error-messages="cepErro"
            @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
            @beforeinput="bloquearEmoji"
            @blur="validarCepAoSair"
          />
        </v-col>

        <v-col class="pt-0 pb-0" cols="8">
          <e-label>Cidade</e-label>

          <v-text-field
            id="franquia-cidade"
            data-testid="franquia-cidade"
            v-model="form.cidade"
            label="Cidade"
            type="text"
            dense
            solo
            :maxlength="TAMANHO_TEXTO"
            :counter="TAMANHO_TEXTO"
            @compositionend.native="(event) => sanitizarTexto('cidade', event.target.value)"
            @beforeinput="bloquearEmoji"
            @input="(valor) => sanitizarTexto('cidade', valor)"
          />
        </v-col>

        <v-col class="pt-0 pb-0" cols="2">
          <e-label>Estado</e-label>

          <v-text-field
            id="franquia-estado"
            data-testid="franquia-estado"
            v-model="form.estado"
            label="UF"
            type="text"
            dense
            solo
            :maxlength="TAMANHO_UF"
            :counter="TAMANHO_UF"
            @compositionend.native="(event) => sanitizarTexto('estado', event.target.value)"
            @beforeinput="bloquearEmoji"
            @input="(valor) => sanitizarTexto('estado', valor)"
          />
        </v-col>

        <v-col class="pt-0 pb-0" cols="6">
          <e-label>Bairro</e-label>

          <v-text-field
            id="franquia-bairro"
            data-testid="franquia-bairro"
            v-model="form.bairro"
            label="Bairro"
            type="text"
            dense
            solo
            :maxlength="TAMANHO_TEXTO"
            :counter="TAMANHO_TEXTO"
            @compositionend.native="(event) => sanitizarTexto('bairro', event.target.value)"
            @beforeinput="bloquearEmoji"
            @input="(valor) => sanitizarTexto('bairro', valor)"
          />
        </v-col>

        <v-col class="pt-0 pb-0" cols="6">
          <e-label>Logradouro</e-label>

          <v-text-field
            id="franquia-logradouro"
            data-testid="franquia-logradouro"
            v-model="form.logradouro"
            label="Logradouro"
            type="text"
            dense
            solo
            :maxlength="TAMANHO_TEXTO"
            :counter="TAMANHO_TEXTO"
            @compositionend.native="(event) => sanitizarTexto('logradouro', event.target.value)"
            @beforeinput="bloquearEmoji"
            @input="(valor) => sanitizarTexto('logradouro', valor)"
          />
        </v-col>

        <v-col class="pt-0 pb-0" cols="2">
          <e-label>Número</e-label>

          <v-text-field
            id="franquia-numero"
            data-testid="franquia-numero"
            v-model="form.numero"
            label="Número"
            type="text"
            dense
            solo
            :maxlength="TAMANHO_NUMERO"
            :counter="TAMANHO_NUMERO"
            @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
            @compositionend.native="
              (event) => sanitizarNumero('numero', event.target.value, TAMANHO_NUMERO)
            "
            @beforeinput="bloquearEmoji"
            @input="(valor) => sanitizarNumero('numero', valor, TAMANHO_NUMERO)"
          />
        </v-col>

        <v-col class="pt-0 pb-0" cols="2">
          <e-label>Telefone</e-label>

          <v-text-field
            id="franquia-telefone"
            data-testid="franquia-telefone"
            v-model="form.telefone"
            label="Telefone"
            type="text"
            dense
            solo
            :maxlength="TAMANHO_TELEFONE"
            :counter="TAMANHO_TELEFONE"
            @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
            @compositionend.native="(event) => sanitizarTelefone('telefone', event.target.value)"
            @beforeinput="bloquearEmoji"
            @input="(valor) => sanitizarTelefone('telefone', valor)"
          />
        </v-col>

        <v-col class="pt-0 pb-0" cols="2">
          <e-label>Celular 1</e-label>

          <v-text-field
            id="franquia-celular"
            data-testid="franquia-celular"
            v-model="form.celular"
            label="Celular 1"
            type="text"
            dense
            solo
            :maxlength="TAMANHO_TELEFONE"
            :counter="TAMANHO_TELEFONE"
            @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
            @compositionend.native="(event) => sanitizarTelefone('celular', event.target.value)"
            @beforeinput="bloquearEmoji"
            @input="(valor) => sanitizarTelefone('celular', valor)"
          />
        </v-col>

        <v-col class="pt-0 pb-0" cols="2">
          <e-label>Celular 2</e-label>

          <v-text-field
            id="franquia-celular2"
            data-testid="franquia-celular2"
            v-model="form.celular2"
            label="Celular 2"
            type="text"
            dense
            solo
            :maxlength="TAMANHO_TELEFONE"
            :counter="TAMANHO_TELEFONE"
            @keypress="(event) => bloquearCaractere(event, CLASSE_NUMERO)"
            @compositionend.native="(event) => sanitizarTelefone('celular2', event.target.value)"
            @beforeinput="bloquearEmoji"
            @input="(valor) => sanitizarTelefone('celular2', valor)"
          />
        </v-col>

        <v-col class="pt-0 pb-0" cols="6">
          <e-label>E-mail</e-label>

          <v-text-field
            id="franquia-email"
            data-testid="franquia-email"
            v-model="form.email"
            label="E-mail"
            type="text"
            dense
            solo
            :maxlength="TAMANHO_TEXTO"
            :counter="TAMANHO_TEXTO"
            :error-messages="emailErro"
            hint="Utilizado no cabeçalho do Histórico Acadêmico"
            persistent-hint
            @compositionend.native="(event) => sanitizarTexto('email', event.target.value)"
            @beforeinput="bloquearEmoji"
            @input="(valor) => sanitizarTexto('email', valor)"
          />
        </v-col>

        <v-col cols="12">
          <v-btn
            id="franquia-enviar"
            data-testid="franquia-enviar"
            color="primary"
            :disabled="criandoFranquia"
            :loading="criandoFranquia"
            type="submit"
            block
            >Enviar Dados</v-btn
          >
        </v-col>
      </v-row>
    </form>
  </main-template>
</template>

<script>
const CLASSE_NOME = "A-Za-zÀ-ÖØ-öø-ÿ0-9 .,'\\-&/()ºª©®™";
const CLASSE_NUMERO = "0-9";

const TAMANHO_CEP = 9;
const TAMANHO_CNPJ = 18;
const TAMANHO_CODIGO = 50;
const TAMANHO_NUMERO = 10;
const TAMANHO_TELEFONE = 15;
const TAMANHO_TEXTO = 191;
const TAMANHO_UF = 2;

const MENSAGEM_CARACTERE_REMOVIDO = "Caracteres não permitidos foram removidos.";

const REGEX_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const REGEX_EMOJI =
  /[\uD800-\uDFFF]|[\u2190-\u21FF\u2300-\u27BF\u2934\u2935\u2B00-\u2BFF\u3030\u303D\u3297\u3299]|\uFE0F|\u200D|\u20E3/g;

const formularioVazio = () => ({
  bairro: null,
  celular: null,
  celular2: null,
  cep: null,
  cidade: null,
  cnpj: null,
  codigo: null,
  descricao: null,
  email: null,
  estado: null,
  logradouro: null,
  numero: null,
  telefone: null,
});

const formatarTelefoneBR = (valor) => {
  const digitos = `${valor ?? ""}`.replace(/\D/g, "").slice(0, 11);
  if (digitos.length <= 2) {
    return digitos;
  }

  if (digitos.length <= 6) {
    return `(${digitos.slice(0, 2)}) ${digitos.slice(2)}`;
  }

  if (digitos.length <= 10) {
    return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 6)}-${digitos.slice(6)}`;
  }

  return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 7)}-${digitos.slice(7)}`;
};

const removerCaracteresInvalidos = (valor, classe) =>
  `${valor ?? ""}`.replace(new RegExp(`[^${classe}]`, "g"), "");

const removerEmojis = (valor) => `${valor ?? ""}`.replace(REGEX_EMOJI, "");

export default {
  props: {
    editing: {
      default: false,
      type: Boolean,
    },
  },

  data() {
    return {
      buscandoCep: false,
      carregandoFranquia: false,
      cepErro: [],
      cepValido: false,
      CLASSE_NOME,
      CLASSE_NUMERO,
      criandoFranquia: false,
      form: formularioVazio(),
      nomeErro: [],
      TAMANHO_CEP,
      TAMANHO_CNPJ,
      TAMANHO_CODIGO,
      TAMANHO_NUMERO,
      TAMANHO_TELEFONE,
      TAMANHO_TEXTO,
      TAMANHO_UF,
    };
  },

  computed: {
    emailErro() {
      const email = `${this.form.email ?? ""}`.trim();
      if (!email) return [];
      return REGEX_EMAIL.test(email) ? [] : ["E-mail inválido"];
    },
  },

  watch: {
    "form.cep": function watchCep(cepAtual, cepAnterior) {
      if (this.carregandoFranquia || cepAtual === cepAnterior) return;

      this.cepErro = [];

      const digitos = this.$services.cepService.limparCep(cepAtual);
      if (digitos.length === 8) {
        this.buscarEnderecoPeloCep(digitos);
        return;
      }

      this.cepValido = false;
    },
  },

  async mounted() {
    if (!this.editing) return;
    await this.carregarFranquia();
  },

  methods: {
    /**
     * Impede a digitação de caracteres fora da classe permitida do campo.
     * --
     * @param {KeyboardEvent} event - Evento de tecla
     * @param {string} classe - Classe de caracteres aceitos
     */
    bloquearCaractere(event, classe) {
      if (event.ctrlKey || event.metaKey || event.altKey) return;

      const tecla = event.key;
      if (!tecla || tecla.length !== 1) return;

      if (!new RegExp(`^[${classe}]$`).test(tecla)) {
        event.preventDefault();
      }
    },

    /**
     * Impede a inserção de emojis, inclusive por colagem ou teclado virtual.
     * --
     * @param {InputEvent} event - Evento de entrada
     */
    bloquearEmoji(event) {
      if (event.data && /\p{Extended_Pictographic}/u.test(event.data)) {
        event.preventDefault();
      }
    },

    async buscarEnderecoPeloCep(digitos) {
      this.buscandoCep = true;
      try {
        const localizacao = await this.$services.cepService.buscarDadosDoCep(digitos);

        this.cepValido = true;
        this.cepErro = [];
        this.form = {
          ...this.form,
          cidade: localizacao.cidade,
          estado: localizacao.estado,
          bairro: localizacao.bairro,
          logradouro: localizacao.rua,
        };
      } catch (error) {
        this.marcarCepInvalido();
      } finally {
        this.buscandoCep = false;
      }
    },

    async carregarFranquia() {
      this.carregandoFranquia = true;
      try {
        const { franquia_id } = this.$route.params;
        const franquia = await this.$services.franquiasService.getFranquia(franquia_id);

        this.form = { ...formularioVazio(), ...(franquia || {}) };
        this.cepValido = this.$services.cepService.cepEhValido(this.form.cep);
      } catch (error) {
        this.$handleError(error);
      } finally {
        await this.$nextTick();
        this.carregandoFranquia = false;
      }
    },

    limparEnderecoAutomatico() {
      this.form = {
        ...this.form,
        cidade: null,
        estado: null,
        bairro: null,
        logradouro: null,
      };
    },

    marcarCepInvalido() {
      this.cepValido = false;
      this.cepErro = ["CEP inválido: preencha o endereço manualmente. O CEP não será salvo."];
      this.limparEnderecoAutomatico();
    },

    montarPayload() {
      return {
        ...this.form,
        cep: this.cepValido ? this.form.cep : null,
        email: `${this.form.email ?? ""}`.trim() || null,
      };
    },

    /**
     * Remove do nome da unidade os caracteres fora da classe permitida e
     * avisa o usuário quando algo foi descartado.
     * --
     * @param {string} valor - Valor digitado
     */
    sanitizarNome(valor) {
      const limpo = removerCaracteresInvalidos(removerEmojis(valor), CLASSE_NOME);

      this.nomeErro = limpo === `${valor ?? ""}` ? [] : [MENSAGEM_CARACTERE_REMOVIDO];
      this.form.descricao = limpo;
    },

    /**
     * Mantém apenas dígitos no campo, respeitando o tamanho máximo.
     * --
     * @param {string} campo - Nome da propriedade do formulário
     * @param {string} valor - Valor digitado
     * @param {number} tamanho - Quantidade máxima de dígitos
     */
    sanitizarNumero(campo, valor, tamanho) {
      this.form[campo] = removerCaracteresInvalidos(valor, CLASSE_NUMERO).slice(0, tamanho);
    },

    sanitizarTelefone(campo, valor) {
      this.form[campo] = formatarTelefoneBR(valor);
    },

    sanitizarTexto(campo, valor) {
      this.form[campo] = removerEmojis(valor);
    },

    async submitForm() {
      if (this.emailErro.length) {
        this.$toast.danger("Informe um e-mail válido");
        return;
      }

      this.criandoFranquia = true;
      try {
        const payload = this.montarPayload();

        if (this.editing) {
          await this.$services.franquiasService.atualizarFranquia(payload);
        } else {
          await this.$services.franquiasService.criarFranquia(payload);
        }

        this.$toast.success("Franquia Atualizada com sucesso");
        this.$router.push({ name: "franquias" });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.criandoFranquia = false;
      }
    },

    validarCepAoSair() {
      if (this.buscandoCep) return;

      const digitos = this.$services.cepService.limparCep(this.form.cep);
      if (!digitos.length) {
        this.cepErro = [];
        this.cepValido = false;
        return;
      }
      if (digitos.length !== 8) {
        this.marcarCepInvalido();
      }
    },
  },
};
</script>
